module.exports = __webpack_public_path__ + "media/images/home/main/aa/pakalpojumu_sniedzeji-6cd79018a0e40e5f5fb3ec5178d8ab5a.png";